import React, { useState, useCallback } from "react";
import "../PlaceholderPage.css";
import "../AIAgents.css";
import "./SimulatoreCostiDipendenti.css";
import FormSimulazione from "./components/FormSimulazione";
import StoricoSimulazioni from "./components/StoricoSimulazioni";

const SimulatoreCostiDipendenti = () => {
    const [activeTab, setActiveTab] = useState("nuova");
    const [editingRecord, setEditingRecord] = useState(null);
    const [storicoRefreshTick, setStoricoRefreshTick] = useState(0);

    const handleOpenFromStorico = useCallback((record) => {
        setEditingRecord(record);
        setActiveTab("nuova");
    }, []);

    const handleResetForm = useCallback(() => {
        setEditingRecord(null);
    }, []);

    const handleSavedOrUpdated = useCallback(() => {
        setStoricoRefreshTick(t => t + 1);
    }, []);

    return (
        <div className="placeholder-container simulatore-costi-container">
            <header className="page-header">
                <div className="header-content">
                    <div className="header-title">
                        <h2>Simulatore Costi Dipendente</h2>
                        <p className="header-subtitle">
                            Netto, costo azienda e costo orario reale da livello CCNL e ore settimanali
                        </p>
                    </div>
                </div>
            </header>

            <div className="content-area">
                <div className="simulatore-tabs">
                    <button
                        className={`simulatore-tab ${activeTab === "nuova" ? "active" : ""}`}
                        onClick={() => setActiveTab("nuova")}
                    >
                        {editingRecord ? "Modifica Simulazione" : "Nuova Simulazione"}
                    </button>
                    <button
                        className={`simulatore-tab ${activeTab === "storico" ? "active" : ""}`}
                        onClick={() => { setActiveTab("storico"); setEditingRecord(null); }}
                    >
                        Storico
                    </button>
                </div>

                {/* Entrambi i tab restano montati: cambia solo la visibilita'.
                    Cosi' il form mantiene il contenuto compilato anche quando
                    l'utente passa a "Storico" e torna indietro. */}
                <div style={{ display: activeTab === "nuova" ? "block" : "none" }}>
                    <FormSimulazione
                        editingRecord={editingRecord}
                        onReset={handleResetForm}
                        onSavedOrUpdated={handleSavedOrUpdated}
                    />
                </div>
                <div style={{ display: activeTab === "storico" ? "block" : "none" }}>
                    <StoricoSimulazioni
                        onOpen={handleOpenFromStorico}
                        refreshTick={storicoRefreshTick}
                    />
                </div>
            </div>
        </div>
    );
};

export default SimulatoreCostiDipendenti;
